/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import { AbilityBuilder, Ability } from '@casl/ability';
import {
  ADMIN_CANNOT_ABILITY,
  ADMIN_CAN_ABILITY,
  MASTER_ADMIN_CAN_ABILITY,
} from './admin';
import { EMPLOYEE_CAN_ABILITY, EMPLOYEE_CANNOT_ABILITY } from './employee';
import {
  PLATFORM_OWNER_CANNOT_ABILITY,
  PLATFORM_OWNER_CAN_ABILITY,
} from './platformOwner';
import {
  COMPANY_OWNER_CAN_ABILITY,
  COMPANY_OWNER_CANNOT_ABILITY,
} from './companyOwner';
import {
  CONTACT_PERSON_CANNOT_ABILITY,
  CONTACT_PERSON_CAN_ABILITY,
} from './contactPerson';
import {
ISSUER_CANNOT_ABILITY,
ISSUER_CAN_ABILITY
} from "./issuer";

export const defineAbilityFor = (whoami: string) => {
  const ability: any = new AbilityBuilder(Ability);
  if (whoami === 'owner1') {
    ability.can('manage', 'all'); // read-write access to everything
  } else if (whoami === 'admin') {
    ADMIN_CAN_ABILITY?.forEach((able: any) => {
      if (able[0] && able[1]) {
        ability.can(able[0], able[1]);
      }
    });

    ADMIN_CANNOT_ABILITY?.forEach((able: any) => {
      if (able[0] && able[1]) {
        ability.cannot(able[0], able[1]);
      }
    });
  } else if (whoami === 'prospective_employee') {
    EMPLOYEE_CAN_ABILITY?.forEach((able: any) => {
      if (able[0] && able[1]) {
        ability.can(able[0], able[1]);
      }
    });

    EMPLOYEE_CANNOT_ABILITY?.forEach((able: any) => {
      if (able[0] && able[1]) {
        ability.cannot(able[0], able[1]);
      }
    });
  } else if (whoami === 'platform_owner') {
    PLATFORM_OWNER_CAN_ABILITY?.forEach((able: any) => {
      if (able[0] && able[1]) {
        ability.can(able[0], able[1]);
      }
    });

    PLATFORM_OWNER_CANNOT_ABILITY?.forEach((able: any) => {
      if (able[0] && able[1]) {
        ability.cannot(able[0], able[1]);
      }
    });
  } else if (whoami === 'owner') {
    COMPANY_OWNER_CAN_ABILITY?.forEach((able: any) => {
      if (able[0] && able[1]) {
        ability.can(able[0], able[1]);
      }
    });

    COMPANY_OWNER_CANNOT_ABILITY?.forEach((able: any) => {
      if (able[0] && able[1]) {
        ability.cannot(able[0], able[1]);
      }
    });
  } else if (whoami === 'agent') {
    COMPANY_OWNER_CAN_ABILITY?.forEach((able: any) => {
      if (able[0] && able[1]) {
        ability.can(able[0], able[1]);
      }
    });

    COMPANY_OWNER_CANNOT_ABILITY?.forEach((able: any) => {
      if (able[0] && able[1]) {
        ability.cannot(able[0], able[1]);
      }
    });
  } else if (whoami === 'contact_person') {
    CONTACT_PERSON_CAN_ABILITY?.forEach((able: any) => {
      if (able[0] && able[1]) {
        ability.can(able[0], able[1]);
      }
    });

    CONTACT_PERSON_CANNOT_ABILITY?.forEach((able: any) => {
      if (able[0] && able[1]) {
        ability.cannot(able[0], able[1]);
      }
    });
  } else if (whoami === 'issuer') {
    ISSUER_CAN_ABILITY?.forEach((able: any) => {
      if (able[0] && able[1]) {
        ability.can(able[0], able[1]);
      }
    });

    ISSUER_CANNOT_ABILITY?.forEach((able: any) => {
      if (able[0] && able[1]) {
        ability.cannot(able[0], able[1]);
      }
    });
  }
  else {
    ability.cannot('read', 'all'); // read-only access to everything
  }

  return ability.build();
};
